import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import CaseInjuriesGraphModel from "../../models/case-injuries-graph";

export default class CaseInjuriesGraphRepository extends BaseRepository {
  static modelClass = CaseInjuriesGraphModel;
  modelName = "case-injuries-graph";

  async query(caseId) {
    return await super.query({
      urlPath: `case/${caseId}/injury_graph/`,
    });
  }
}
